module.exports = __webpack_public_path__ + "static/infinity-9d966e1a77264ad7b97d0879297ad51b.jpg";